import React from 'react';
import Peep from 'react-peeps';
import Panel from '../panels/Panel';
import { CustomizeStep } from './constants.mjs';
import { useRouter } from 'next/router';

const FinalizeAvatar = ({setState, avatarState, username, player, onSave}) => {
    const displayedName = username.split(' \#') ? username.split(' \#')[0] : username
    const router = useRouter()

    const handleSave = async () => {
        await fetch(`/api/user/${player?.uid}`,
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    avatar: avatarState,
                    username: username
                })
            }
        )

        if(onSave) {
            onSave()
        } else {
            setState(CustomizeStep.DISCLAIMER)
        }
    }
    return <Panel title={'Finalize your avatar'}>

            <div className={'grid place-items-center grid-cols-5 gap-10 justify-center mt-2'}>
				<div className={'relative w-24 h-3 col-start-2 rounded-sm shadow bg-staff bg-opacity-25'} />
				<div className={'relative w-24 h-3 col-start-3 rounded-sm shadow bg-staff bg-opacity-25'} />
				<div className={'relative w-24 h-3 col-start-4 rounded-sm shadow bg-staff bg-opacity-75'} />
			</div>  

            <h1 className={'text-center leading-8 font-gBlack text-4xl text-primary mt-2 mx-4'}>Are you finished creating your Triviatar?</h1>
            <p className={'text-center leading-5 font-gReg text-xl text-primary my-2 px-4'}>{"Don't worry, your name and look can be changed later in the settings. Tap your icon in the top right to edit."}</p>
            <div className={'grid place-items-center'}>
            <Peep
                style={{
                    width: 200,
                    height: 200,
                    justifyContent: 'center',
                    alignSelf: 'center'
                }}
                circleStyle={avatarState?.circleStyle} // Get to this later
                accessory={avatarState?.accessory}
                body={avatarState?.body}
                face={avatarState?.face}
                hair={avatarState?.hair}
                facialHair={avatarState?.facialHair}
                backgroundColor={avatarState?.backgroundColor}
                viewBox={{ x: '90', y: '0', width: '1050', height: '1000' }}
                strokeColor='#000000'
            />
            </div>
            <h1 className={'text-center font-gBlack text-3xl text-primary my-2'}>{displayedName}</h1>
            <div className={'grid grid-cols-4 justify-center place-items-center gap-2 my-2'}>
            <button 
						className={
							"flex bg-primary py-2 col-start-2 rounded-md font-gBold uppercase px-4 justify-center text-xl"
						}
						onClick={() => setState(CustomizeStep.CUSTOMIZE)}
						data-testid={`button-back`}
					>
						Back
					</button>
            <button 
						className={
							"flex bg-primary py-2 rounded-md font-gBold uppercase px-4 justify-center text-xl"
						}
						onClick={handleSave}
						data-testid={`button-save`}
					>
						Finish
					</button>
            </div>
        </Panel>
};

export default FinalizeAvatar;